import {
  ClientPricingItemTypeEnum,
  NestedItemObjectDataOutputDto,
  ServiceProvisionTypeEnum,
} from '../../../../../../lib/graphql'
import { IconProps } from '../../../../../atoms/icons/icon'

export const getNestedItemIcon = ({
  nestedItem,
}: {
  nestedItem: Pick<
    NestedItemObjectDataOutputDto,
    'type' | 'serviceProvisionType'
  >
}): IconProps['name'] => {
  const { type, serviceProvisionType } = nestedItem

  switch (type) {
    case ClientPricingItemTypeEnum.INDIVIDUAL_BEDROOMS:
    case ClientPricingItemTypeEnum.SHARED_BEDROOMS:
    case ClientPricingItemTypeEnum.HOUSE_PRICE:
      return 'bedroom'
    case ClientPricingItemTypeEnum.EARLY_CHECKIN:
      return 'early-check-in'
    case ClientPricingItemTypeEnum.LATE_CHECKOUT:
      return 'late-checkout'
    case ClientPricingItemTypeEnum.DAY_PACKAGE:
    case ClientPricingItemTypeEnum.HALF_DAY_PACKAGE:
    case ClientPricingItemTypeEnum.RESIDENTIAL_SEMINAR:
      return 'workspace'
    case ClientPricingItemTypeEnum.LAUNDRY:
      return 'laundry'
    case ClientPricingItemTypeEnum.CLEANING:
      return 'cleaning'
    case ClientPricingItemTypeEnum.SERVICE_PROVISION: {
      switch (serviceProvisionType) {
        // TODO-AHL: ajouter GROCERY_DELIVERY
        case ServiceProvisionTypeEnum.BREAKFAST:
          return 'breakfast'
        case ServiceProvisionTypeEnum.LUNCH:
          return 'lunch'
        case ServiceProvisionTypeEnum.DINNER:
          return 'dinner'
        case ServiceProvisionTypeEnum.MEAL_DRINK:
        case ServiceProvisionTypeEnum.DRINK:
        case ServiceProvisionTypeEnum.APERITIF:
          return 'wine'
        case ServiceProvisionTypeEnum.PERMANENT_SNACK:
        case ServiceProvisionTypeEnum.MORNING_SNACK:
        case ServiceProvisionTypeEnum.AFTERNOON_SNACK:
        case ServiceProvisionTypeEnum.WELCOME_COFFEE:
          return 'coffee'
        case ServiceProvisionTypeEnum.PRIVATIZATION:
        case ServiceProvisionTypeEnum.SPACE:
          return 'workspace'
        default:
          return 'challenge-sport'
      }
    }
    default:
      return 'bedroom'
  }
}

export const getNestedItemQuantity = ({
  nestedItem,
}: {
  nestedItem: Pick<NestedItemObjectDataOutputDto, 'quantity' | 'type'>
}): string => {
  const shouldShowQuantityIfOne =
    nestedItem.type === ClientPricingItemTypeEnum.INDIVIDUAL_BEDROOMS ||
    nestedItem.type === ClientPricingItemTypeEnum.SHARED_BEDROOMS ||
    nestedItem.type === ClientPricingItemTypeEnum.DAY_PACKAGE

  if (nestedItem.quantity > 1 || shouldShowQuantityIfOne) {
    return ` x ${nestedItem.quantity}`
  }
  return ''
}

export const getNestedItemUnit = ({
  nestedItem,
}: {
  nestedItem: Pick<NestedItemObjectDataOutputDto, 'type' | 'quantity'>
}): string => {
  const { type, quantity } = nestedItem
  switch (type) {
    case ClientPricingItemTypeEnum.INDIVIDUAL_BEDROOMS:
    case ClientPricingItemTypeEnum.SHARED_BEDROOMS:
    case ClientPricingItemTypeEnum.HOUSE_PRICE:
      return `${quantity > 1 ? ' nuits' : ' nuit'}`
    case ClientPricingItemTypeEnum.DAY_PACKAGE:
      return `${quantity > 1 ? ' jours' : ' jour'}`
    default:
      return ''
  }
}
